export default "__VITE_ASSET__FG99NFCC__"